/**
 * Better Auth Client
 * Provides authentication hooks and methods for React
 */
import { createAuthClient } from "better-auth/react";
import {
  organizationClient,
  magicLinkClient,
  adminClient,
} from "better-auth/client/plugins";

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || "",
  plugins: [organizationClient(), magicLinkClient(), adminClient()],
});

// Export commonly used hooks and methods
export const {
  useSession,
  signIn,
  signUp,
  signOut,
  useActiveOrganization,
  useListOrganizations,
  // Organization methods
  organization,
  // Admin methods (impersonation)
  admin,
} = authClient;

// Password reset methods
// Better Auth 1.4+ renamed forgetPassword -> requestPasswordReset
// /api/auth/request-password-reset -> authClient.requestPasswordReset
// /api/auth/reset-password -> authClient.resetPassword
export const forgetPassword = authClient.requestPasswordReset;
export const resetPassword = authClient.resetPassword;
